export default "__VITE_ASSET__D7H$6RWB__"